import React from 'react';
import { InputText } from 'primereact/inputtext';
import InputWrapper from './InputWrapper';

const PrimeInput = ({ value, onChange, placeholder, label, error, name }) => {
  return (
    <InputWrapper label={label} error={error}>
      <InputText className="w-100" value={value} onChange={onChange} placeholder={placeholder} name={name} />
    </InputWrapper>
  );
};

export default PrimeInput;